const LEADING_CURRENCY_SYMBOL = /^\p{Currency_Symbol}/u

export default class TicketPrices {
  constructor(data) {
    this.data = data;
  }

  priceRange() {
    const price_array = [];
    const prices = this.data;
    let price;

    for (let key in prices) {
      if (prices[key]) {
        price = prices[key].trim();

        if (!price.match(LEADING_CURRENCY_SYMBOL) && this.price_symbol(price).length == 1) {
          price = this.price_symbol(price) + this.price_amount(price);
        }

        price_array.push(price);
      }
    }

    if (price_array.length == 1) {
      if (parseFloat(price_array[0].replaceAll(/\D/g, "").match(/[0-9\.]+/)[0]) === 0) {
        return 'Free';
      }
      return price_array[0];
    }

    price_array.sort(function (a, b) {
      const aParsed = a.replaceAll(/\D/g, "").match(/[0-9\.]+/);
      const bParsed = b.replaceAll(/\D/g, "").match(/[0-9\.]+/);

      if (aParsed && aParsed[0] && bParsed && bParsed[0]) {
        return parseFloat(aParsed[0]) - parseFloat(bParsed[0]);
      } else {
        return 0;
      }
    });

    return price_array[0] + ' - ' + price_array[price_array.length - 1];
  }

  price_symbol(price) {
    const currency_code = price.substring(0, 3);
    switch (currency_code) {
      case 'GBP':
        return '£';
        break;
      case 'EUR':
        return '€';
        break;
      case 'USD':
      case 'AUD':
      case 'CAD':
        return '$';
        break;
      default:
        return currency_code;
    }
  }

  orderedPrices() {
    const prices = this.data;
    if (!prices) {
      return [];
    }

    const unorderedPrices = Object.keys(prices).map((key) => {
      return prices[key];
    });

    return unorderedPrices.sort((object1, object2) => {
      return this.price_amount(object1) - this.price_amount(object2);
    });
  }

  price_amount(price) {
    if (
      price &&
      price.split(' ').length &&
      !isNaN(price.split(' ')[1]) &&
      price.split(' ')[1].length
    ) {
      return parseFloat(price.split(' ')[1]).toFixed(2);
    }
    if (!isNaN(price)) {
      return parseFloat(price);
    }
  }
}
